export interface IResourceAccessUsageReportArgs {
    organizationIds: string[];
    /** Inclusive start of the range, `YYYY-MM-DD`. */
    from: string;
    /** Inclusive end of the range, `YYYY-MM-DD`. */
    to: string;
    /** Defaults to the routing matrix resource when omitted. */
    resource?: string;
}
